import { getShortDurationTimeUtil } from 'packages/src'
import { SET_DATA_KEY } from '../constants'

export * from './create-from-exercise-type'
export * from './get-count-key'
export * from './get-estimated-rate-of-perceived-exertion'
export * from './get-set-duration'
export * from './is-set-rest'
export * from './update-count'
export * from './update-count-key'
export * from './update-notes'
export * from './update-time-elapsed'
export * from './update-weight'
export * from './update-weight-key'
export * from './update-weight-unit'
export * from './clone'
export * from './get-exercise'
export * from './get-set-data'

export function getCountValueLabelSetUtil (countKey, value) {
  if (countKey === SET_DATA_KEY.REPS) {
    return value + ''
  }

  return getShortDurationTimeUtil(value)
}
